
import { Mixins, Component } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import ETable from "@/components/ETable.vue";
import loading from "@/mixins/loading";
import resize from "@/mixins/resize";
import { getCareExpendList } from "@/api/product"
import dayjs from "dayjs";

const curDomain = `${window.location.origin}`;

@Component({
  components: { ETable }
})
export default class productCodeUse extends Mixins(loading, tablePagination, resize) {
  queryForm = {
    times: [],
    storeName: "",
    storeShowName: "",
    merchantName: "",
    nickname: "",
    productName: "",
    codeId: "",
  };
  itemTotal = 0;
  tableData = [];

  columns = [
    { label: "品牌", prop: "merchantName", minWidth: "120px" },
    { label: "关联门店", prop: "storeName", minWidth: "160px" },
    { label: "关联外显门店", prop: "storeShowName", minWidth: "160px" },
    { label: "产品分类名称", prop: "presCategoryName", minWidth: "140px" },
    { label: "产品名称", prop: "productName", minWidth: "150px" },
    { label: "产品编码", prop: "codeId", minWidth: "120px" },
    { label: "操作时间", prop: "createTime", width: "120px" },
    { label: "操作人", prop: "nickname", width: "120px" },
  ]
  mounted() {
    this.windowResize();
    this.getData();
  }

  searchData() {
    this.resetCurrent();
    this.getData();
  }

  getData() {
    const { times } = this.queryForm;
    const params = {
      ...this.queryForm,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
      fromDate: (times || [])[0] && dayjs((times || [])[0]).format("YYYY-MM-DD HH:mm:ss"),
      toDate: (times || [])[1] && dayjs((times || [])[1]).format("YYYY-MM-DD HH:mm:ss"),
    }
    this.showLoading();
    getCareExpendList(params).then((res) => {
      this.tableData = res.data.list;
      this.itemTotal = res.data.total;
    })
  }
}

